import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2968171797 from "../../../../../packages/component/src/components/badge/demo/demo1.js?loadDemo";
import legacyImportDemo_2135522710 from "../../../../../packages/component/src/components/badge/demo/demo2.js?loadDemo";
import legacyImportDemo_3730238871 from "../../../../../packages/component/src/components/badge/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2968171797,
  legacyImportDemo_2135522710,
  legacyImportDemo_3730238871,
  React
};